import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { updateMatch, UpdateMatchData } from '@/services/actions/updateMatch';
import { Result } from '@/entities';

interface ChangePlayerOptions {
	onSuccessCallback?: () => void;
}

export const useChangePlayerMutation = (options?: ChangePlayerOptions) => {
	return useMutation({
		mutationFn: (data: UpdateMatchData) => updateMatch(data),
		onError: (error: Error) => {
			toast.error(error.message || 'Unable to update player selection. Please try again.');
		},
		onSuccess: (result: Result<void>) => {
			if (result.statusCode === 200) {
				toast.success('Player lineup successfully updated.');
				if (options?.onSuccessCallback) {
					options.onSuccessCallback();
				}
			} else {
				toast.error(result.error || 'Unable to update player selection. Please try again.');
			}
		}
	});
};
